import { safeDivision } from 'utils/format'

const unavailableWithoutInputs = (hasInputs, value) =>
  hasInputs ? value : '-'

export const formatStoreDataToExcel = (store, hasInputs = true) => [
  'Loja',
  '-',
  store.total.sold ?? 0,
  unavailableWithoutInputs(hasInputs, store.projection?.sold ?? 0),
  store.metric.acDayGoal ?? 0,
  safeDivision(store.total.sold / store.metric.acDayGoal),
  store.monthGoal ?? 0,
  '-',
  '-',
  '-',
  '-',
  '-',
  '-',
  '-',
  '-',
  '-',
  '-',
  '-',
  '-',
  '-',
  '-',
  store.total.sales ?? 0,
  Math.ceil(store.dynamicGoal.sales),
  unavailableWithoutInputs(
    hasInputs,
    safeDivision(store.total.sold / store.total.sales)
  ),
  store.dynamicGoal.ticket,
  unavailableWithoutInputs(
    hasInputs,
    safeDivision(store.total.items / store.total.sales)
  ),
  store.dynamicGoal.itemsSale,
  unavailableWithoutInputs(
    hasInputs,
    safeDivision(store.total.sold / store.total.items)
  ),
  store.dynamicGoal.price,
  store.total.items ?? 0,
  Math.ceil(store.dynamicGoal.items)
]

export const formatGroupDataToExcel = ({
  name,
  total,
  projection,
  metric,
  monthGoal,
  dynamicGoal,
  hasInputs = true
}) => [
  name,
  total.sold ?? 0,
  unavailableWithoutInputs(hasInputs, projection?.sold ?? 0),
  metric.acDayGoal ?? 0,
  safeDivision(total.sold / metric.acDayGoal),
  monthGoal ?? 0,
  total.sales ?? 0,
  Math.ceil(dynamicGoal.sales),
  unavailableWithoutInputs(hasInputs, safeDivision(total.sold / total.sales)),
  dynamicGoal.ticket,
  unavailableWithoutInputs(hasInputs, safeDivision(total.items / total.sales)),
  dynamicGoal.itemsSale,
  unavailableWithoutInputs(hasInputs, safeDivision(total.sold / total.items)),
  dynamicGoal.price,
  total.items ?? 0,
  Math.ceil(dynamicGoal.items)
]

export const formatSellerDataToExcel = seller => {
  const hasInputs = seller.hasInputs !== false

  return [
    seller.active
      ? seller.name.complete
      : `(INATIVO) ${seller.name.complete}`,
    seller.cpf ?? 'Não informado',
    seller.total.sold ?? 0,
    unavailableWithoutInputs(hasInputs, seller.projection?.sold ?? 0),
    seller.metric.acDayGoal ?? 0,
    safeDivision(seller.total.sold / seller.metric.acDayGoal),
    seller.monthGoal ?? 0,
    seller.projection?.goal?.name || '-',
    seller.daysWorking || '-',
    seller.commission?.salary ?? '-',
    seller.commission?.complement ?? '-',
    seller.commission?.fixedCommission?.percentage ?? '-',
    seller.commission?.fixedCommission?.value ?? '-',
    seller.commission?.commission?.percentage ?? '-',
    seller.commission?.commission?.value ?? '-',
    seller.commission?.dsrDays ?? '-',
    seller.commission?.dsr ?? '-',
    seller.commission?.bonus?.percentage ?? '-',
    seller.commission?.bonus?.value ?? '-',
    seller.commission?.sumCommission ?? '-',
    seller.projection?.commission?.sumCommission ?? '-',
    seller.total.sales ?? 0,
    Math.ceil(seller.dynamicGoal.sales),
    unavailableWithoutInputs(
      hasInputs,
      safeDivision(seller.total.sold / seller.total.sales)
    ),
    seller.dynamicGoal.ticket,
    unavailableWithoutInputs(
      hasInputs,
      safeDivision(seller.total.items / seller.total.sales)
    ),
    seller.dynamicGoal.itemsSale,
    unavailableWithoutInputs(
      hasInputs,
      safeDivision(seller.total.sold / seller.total.items)
    ),
    seller.dynamicGoal.price,
    seller.total.items ?? 0,
    Math.ceil(seller.dynamicGoal.items)
  ]
}
